import {playCircleSvg as Icon__small__playCircleSvg} from '../Icon__small/Icon__small--playCircle.js';
import {playCircleSvg as Icon__xsmall__playCircleSvg} from '../Icon__xsmall/Icon__xsmall--playCircle.js';

export var playCircle = {
  name: 'playCircle',
  category: 'icon',
  colorable: true,
  svg: Icon__small__playCircleSvg,
  alt: {
    Icon__small: Icon__small__playCircleSvg,
    Icon__xsmall: Icon__xsmall__playCircleSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
